import { render } from "./AppProductDetail.vue?vue&type=template&id=6b6fc09e&scoped=true"
import script from "./AppProductDetail.vue?vue&type=script&lang=js"
export * from "./AppProductDetail.vue?vue&type=script&lang=js"

import "./AppProductDetail.vue?vue&type=style&index=0&id=6b6fc09e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6fc09e"]])

export default __exports__